import CustomCursor from '../../components/feature/CustomCursor';
import ScrollProgress from '../../components/feature/ScrollProgress';
import Navigation from '../../components/feature/Navigation';
import HeroSection from './components/HeroSection';
import WorkSection from './components/WorkSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ cursor: 'none' }}>
      <CustomCursor />
      <ScrollProgress />
      <Navigation />
      
      <main>
        <HeroSection />
        <WorkSection />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
      </main>
      
      <Footer />
    </div>
  );
}
